import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { DisclosureItemContext, defaultDisclosureItemContext, } from './disclosureItem.context';
export const DisclosureItem = ({ children, open = false, ...rest }) => {
    const [isOpen, setIsOpen] = useState(open);
    const disclosureItemContext = {
        ...defaultDisclosureItemContext,
        open: isOpen,
        toggleOpen: () => setIsOpen(!isOpen),
    };
    return (_jsx(DisclosureItemContext.Provider, { value: disclosureItemContext, children: _jsx(DisclosureItemStyled, { ...rest, "data-testid": "Disclosure-item", children: children }) }));
};
const DisclosureItemStyled = styled.div `
  border-top: 1px solid ${({ theme }) => theme.ColorGrey100};

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.ColorGrey100};
  }
`;
//# sourceMappingURL=disclosureItem.js.map